import * as React from "react";
const ChevronLeftSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M12.2929466,3.99983983 L13.0000534,4.70694661 L7.7015668,10.0028398 L13,15.293 L12.2928932,16.0001068 L6.2895668,10.0061485 L6.2925668,10.0028398 L6.29036026,10 L12.2929466,3.99983983 Z" }));
ChevronLeftSmall.displayName = "ChevronLeftSmall";
var ChevronLeftSmall_default = ChevronLeftSmall;
export {
  ChevronLeftSmall_default as default
};
